module.exports = __webpack_public_path__ + "static/media/UNILAG2018003.fb968b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/UNILAG2018003.jpg
// module id = 722
// module chunks = 0